'use client';
import '@/assets/styles/main.scss';
import React from 'react';
import { ErrorComponent } from '@/components';

export default function GlobalError({
  error,
  reset,
}: {
  error: Error & { digest?: string };
  reset: () => void;
}) {
  return (
    <html>
    <head>
      <title>
        {'iKhokha | Payments Made Simple, Business Made Easy'}
      </title>
      <meta
        name="description"
        content="Grow your small business with iKhokha, no-contract card machines, easy payment solutions, free business tools and funding solutions up to R1 million."
      />
    </head>
      <body>
        <ErrorComponent reset={reset} error={error} />
      </body>
    </html>
  );
}
